<template lang="pug">
#cadastrar-monitoramento
    BaseHeader(
        titulo='Novo Monitoramento Socioambiental',
        :voltarPara='voltarPara',
        icon='mdi mdi-play',
        btnTexto='Iniciar monitoramento',
        :exibeBotao='true',
        :desabilitaBotao='desabilitaBotao',
        @btnHeaderClicado='handleIniciarMonitoramento'
    )

    FiltrarTerritorioMonitoramento(
        :isMonitoramentoSocioambiental='true',
        @atualizar-filtro='atualizarFiltro'
    )
    TabelaSelecionarTerritorioMonitoramento(
        v-loading='buscandoTerritorios',
        ref='tableComponent',
        @rows-selecionados-changed='handleRowsSelecionadosChanged',
        :dadosTabelaMonitoramento='dadosTabelaMonitoramento',
        :paginacao='paginacao',
        tipo='SOCIOAMBIENTAL',
        @atualizar-pagina='atualizarPagina',
        @atualizar-tabela='buscarTerritorios'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import FiltrarTerritorioMonitoramento from '@/components/monitoramento/FiltrarTerritorioMonitoramento';
import TabelaSelecionarTerritorioMonitoramento from '@/components/monitoramento/TabelaSelecionarTerritorioMonitoramento';

import MonitoramentoSocioambientalService from '@/services/MonitoramentoSocioambientalService';
import constantes from '@/utils/constantes';

export default {
    name: 'CadastrarMonitoramentoSocioAmbiental',
    components: {
        BaseHeader,
        FiltrarTerritorioMonitoramento,
        TabelaSelecionarTerritorioMonitoramento
    },
    data() {
        return {
            nomeColumn: null,
            desabilitaBotao: true,
            voltarPara: {
                route: 'MonitoramentoSocioambiental'
            },
            paginacao: {
                tamanho: constantes.TAMANHO_PAGINA,
                pagina: 0,
                ordenacao: 'nome'
            },
            filtros: {
                idEstado: null,
                idMunicipio: null,
                idBiomas: [],
                idTerritorios: [],
                idRepresentantes: []
            },
            dadosTabelaMonitoramento: {
                itens: [],
                paginaAtual: 0,
                totalItens: 0
            },
            buscandoTerritorios: true,
            voltarHome: false
        };
    },
    mounted() {
        this.validarRotaComParametro();
    },
    methods: {
        handleIniciarMonitoramento() {
            this.$refs.tableComponent.iniciarMonitoramento();
        },

        handleRowsSelecionadosChanged(rowsSelecionadas) {
            this.desabilitaBotao = rowsSelecionadas.length === 0;
        },

        async buscarTerritorios() {
            this.buscandoTerritorios = true;

            const { data } =
                await MonitoramentoSocioambientalService.buscarTerritoriosNaoMonitorados(
                    this.filtros,
                    this.paginacao
                );

            this.dadosTabelaMonitoramento = data;
            this.buscandoTerritorios = false;
        },

        atualizarFiltro(dados) {
            this.filtros = dados;
            this.paginacao.pagina = 0;
            this.buscarTerritorios();
        },

        atualizarPagina(pagina) {
            this.paginacao.pagina = pagina - 1;
            this.buscarTerritorios();
        },
        validarRotaComParametro() {
            if (this.$route.params.valor && this.$route.params.id) {
                this.voltarPara.route = 'Home';
            }
        }
    }
};
</script>
<style lang="scss" scoped>
#cadastrar-monitoramento {
    .box-instrucao {
        float: left;
        height: 39px;
        margin-right: 14px;
        color: #3b3b3b;
        max-width: 269px;
        font-size: 13px;

        span {
            padding-left: 3px;
            color: #1989fa;
            text-decoration-line: underline;
        }
    }
}
</style>
